import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useState } from "react";
import { getBuyWithFiatStatus, } from "../../../../../../../pay/buyWithFiat/getStatus.js";
import { isSwapRequiredPostOnramp } from "../../../../../../../pay/buyWithFiat/isSwapRequiredPostOnramp.js";
import { openOnrampPopup } from "../openOnRamppopup.js";
import { addPendingTx } from "../swap/pendingSwapTx.js";
import { OnrampStatusScreen } from "./FiatStatusScreen.js";
import { FiatSteps, fiatQuoteToPartialQuote } from "./FiatSteps.js";
import { PostOnRampSwapFlow } from "./PostOnRampSwapFlow.js";
export function FiatFlow(props) {
    const hasTwoSteps = isSwapRequiredPostOnramp(props.quote);
    const [screen, setScreen] = useState(hasTwoSteps
        ? {
            id: "step-1",
        }
        : {
            id: "onramp-status",
        });
    const [popupWindow, setPopupWindow] = useState(props.openedWindow);
    const onPostOnrampSuccess = useCallback(() => {
        // report the status of fiat status instead of post onramp swap status when post onramp swap is successful
        getBuyWithFiatStatus({
            intentId: props.quote.intentId,
            client: props.client,
        }).then((status) => {
            props.onSuccess(status);
        });
    }, [props.onSuccess, props.quote.intentId, props.client]);
    if (screen.id === "step-1") {
        return (_jsx(FiatSteps, { title: props.title, client: props.client, onBack: props.onBack, partialQuote: fiatQuoteToPartialQuote(props.quote), step: 1, onContinue: () => {
                const popup = openOnrampPopup(props.quote.onRampLink, props.theme);
                addPendingTx({
                    type: "fiat",
                    intentId: props.quote.intentId,
                });
                setPopupWindow(popup);
                setScreen({ id: "onramp-status" });
            } }));
    }
    if (screen.id === "onramp-status") {
        return (_jsx(OnrampStatusScreen, { title: props.title, client: props.client, intentId: props.quote.intentId, onBack: props.onBack, hasTwoSteps: hasTwoSteps, openedWindow: popupWindow, quote: props.quote, onDone: props.onDone, onShowSwapFlow: (_status) => {
                setScreen({ id: "postonramp-swap", data: _status });
            }, transactionMode: props.transactionMode, isEmbed: props.isEmbed, onSuccess: props.onSuccess }));
    }
    if (screen.id === "postonramp-swap") {
        return (_jsx(PostOnRampSwapFlow, { title: props.title, status: screen.data, quote: fiatQuoteToPartialQuote(props.quote), client: props.client, onBack: props.onBack, onDone: props.onDone, onSwapFlowStarted: () => {
                // no op
            }, transactionMode: props.transactionMode, isEmbed: props.isEmbed, payer: props.payer, onSuccess: onPostOnrampSuccess }));
    }
    // never
    return null;
}
//# sourceMappingURL=FiatFlow.js.map